import { EventBus, Events, subscribeListeners } from '../lib/events'
import logger from '../lib/logger'

export default (context, inject) => {
  logger.debug('Plugin: Injecting event bus.')

  inject('bus', EventBus)
  inject('events', Events)

  subscribeListeners()
}
